






















import { defineComponent, watch, reactive, computed } from "@vue/composition-api";
import { injectStrict } from "@/lib/utils";
import { RubricStoreKey } from "@/store/StoreInjectionKeys";
import { UserStoreKey } from "@/store/StoreInjectionKeys";
import RubricVersionLinkRenderer from '../components/RubricVersionLinkRenderer.vue'
import RubricVersionStatusRenderer from '../components/RubricVersionStatusRenderer.vue'
import AgTable from '@/modules/ees/components/AgTable.vue'
import { dateTimeFormatters } from '@/lib/formatters/dateTime'
import { RubricVersionStatus } from '@/generated/api.clients'


export default defineComponent({
  components: {
    AgTable
  },
  setup(props, { root }) {
    const rubricStore = injectStrict(RubricStoreKey);
    const userStore = injectStrict(UserStoreKey);

    watch(
      () => root.$route.params.rid,
      async newId => {
        if (newId) {
          await rubricStore.actions.loadRubricVersions(Number(newId))
        }
      }
    ,
    {
      immediate: true
    });

    const table = reactive({ 
      columnDefs: [
        { 
          field: "version",
          flex: 1,
          type: ['nonSortable', 'nonFilterable'],
          cellRendererFramework: RubricVersionLinkRenderer 
        },
        { 
          field: "status",
          type: ['nonSortable', 'nonFilterable'],
          cellRendererFramework: RubricVersionStatusRenderer 
        },
        // {
        //   field: 'created',
        //   filter: false,
        //   width: 250,
        //   cellRenderer: (params) => {
        //     return dateTimeFormatters.toDateTime(params.value)
        //   }
        // },
        // {
        //   field: 'lastModified',
        //   filter: false,
        //   width: 250,
        //   cellRenderer: (params) => {
        //     return dateTimeFormatters.toDateTime(params.value)
        //   }
        // }
      ]
    });

    const filteredRubricVersions = computed(() => {
      if (userStore.getters.isSiteAdmin()) {
        return rubricStore.state.rubricVersions;
      }
      // Non-admins only see Active versions
      return rubricStore.state.rubricVersions.filter(rv => rv.status === RubricVersionStatus.Active);
    });

    return {
      table,
      rubricStore,
      filteredRubricVersions
    };
  }
});
